<script>
    import IndividualTiles from "./tiles/IndividualTiles.svelte"
    
        
    export let w = 400
    export let h = 600
    export let tile = 100
        
        let rows = Math.ceil(h/tile)
    let cols = Math.ceil(w/tile)
    
     
    let fullw = tile*cols
    let fullh = tile* rows
    
    let xshift = fullw-w
    let yshift = fullh-h
    
    
        function randomNumber(n) {
            return Math.floor(Math.random() * n);
        }
    
    </script>
    
    <svg viewbox="0 0 {w} {h}" width="100%" height="100%">
    <rect width="{w}" height="{h}" x=0 y=0 fill="#eee"/>
        
        {#each Array(rows) as _, i}
            {#each Array(cols) as _, ii}
                <g transform="translate({(tile*ii)-(xshift/2)} {(tile*i)-(yshift/2)})">								
                    <IndividualTiles bind:w={tile} bind:h={tile}  tile={randomNumber(24)} />
                <g/>
                </g>
            {/each}	
        {/each}
    </svg>
    
    {randomNumber(2)}
    